// Status: active. D-024 / D-032: org-engagement is the credential owner;
// payments/apps consumes this public-only event and remains the sole forms writer.
import { z } from 'zod';
import { eventEnvelopeSchema } from './base.js';

export const dtdKeysUpdatedEventSchema = eventEnvelopeSchema
  .extend({
    credentialOrganizationId: z.string().regex(/^[a-zA-Z0-9][a-zA-Z0-9._-]*$/),
    nonprofitName: z.string().min(1),
    publicApiKey: z.string(),
  })
  .strict()
  .refine(
    (event) => event.credentialOrganizationId === event.organizationId,
    'Credential owner mismatch',
  );
export type DtdKeysUpdatedEvent = z.infer<typeof dtdKeysUpdatedEventSchema>;
